import { render } from "./BaseBadge.vue?vue&type=template&id=2e1832fc&scoped=true"
import script from "./BaseBadge.vue?vue&type=script&lang=js"
export * from "./BaseBadge.vue?vue&type=script&lang=js"

import "./BaseBadge.vue?vue&type=style&index=0&id=2e1832fc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2e1832fc"

export default script